class PbaSelectionSummary extends HTMLElement {
  connectedCallback() {
    this.productRoot = this.closest('.main-product-template');
    if (!this.productRoot) return;
    this.variants = JSON.parse(this.querySelector('script').textContent);
    this.handleChange = () => this.update();
    this.productRoot.addEventListener('change', this.handleChange);
    this.update();
  }
  disconnectedCallback() { this.productRoot?.removeEventListener('change', this.handleChange); }
  update() {
    const picker = this.productRoot.querySelector('variant-radios, variant-selects');
    if (!picker) return;
    const selected = picker.matches('variant-radios')
      ? Array.from(picker.querySelectorAll('fieldset')).map(field => field.querySelector('input:checked')?.value)
      : Array.from(picker.querySelectorAll('select')).map(select => select.value);
    const variant = this.variants.find(item => item.options.every((option,index) => option === selected[index]));
    this.querySelector('[data-selection-text]').textContent = variant ? variant.title : this.dataset.unavailable;
  }
}
if (!customElements.get('pba-selection-summary')) customElements.define('pba-selection-summary', PbaSelectionSummary);
document.addEventListener('click', event => {
  const close = event.target.closest('[data-pba-close-filters]');
  if (close) {
    const drawer = close.closest('menu-drawer');
    drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
  }
});
